import ResizeableSekeletonText from 'components/shared/skeletons/resizeable-skeleton-text/ResizeableSekeletonText';

export const PlanUpsellBannerSkeleton = () => {
    return (
        <s-section padding="none">
            <div className="flex flex-row items-center justify-between gap-2" style={{ padding: '24px 16px' }}>
                <div className="flex flex-row items-center gap-2.5">
                    <ResizeableSekeletonText width="24px" height="24px" />
                    <div className="flex flex-col gap-1">
                        <ResizeableSekeletonText width="220px" height="20px" />
                        <ResizeableSekeletonText width="280px" height="20px" />
                    </div>
                </div>
                <ResizeableSekeletonText width="120px" height="36px" />
            </div>
        </s-section>
    );
};
